"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Link;
var _react = _interopRequireDefault(require("react"));
var _useEnhancedHref = _interopRequireDefault(require("../../hooks/useEnhancedHref"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function Link(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
    href: (0, _useEnhancedHref["default"])(props.href),
    target: props.newTab ? '_blank' : null,
    rel: props.newTab ? 'noopener noreferrer' : null,
    "data-event": props.eventType || 'ctaClick',
    "data-component": props.componentName,
    "data-section": props.section,
    "data-location": props.linkLocation,
    children: props.title
  });
}